import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import useBonificacionesLogic from "./hooks/useBonificacionesLogic";
import BonificacionesView from "./pages/BonificacionesView";

export default function Bonificaciones() {
  const logic = useBonificacionesLogic();

  return (
    <Routes>
      <Route path="/" element={<BonificacionesView {...logic} />} />
      <Route path="*" element={<Navigate to="." replace />} />
    </Routes>
  );
}
